<template>
    <div style="display: flex; flex-direction: column; position: relative;">
        <div v-if="isShowRequestPopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 100; display: flex; justify-content: center; align-items: center;">
            <div style="width: calc(100% - 24px); background-color: #fff; border-radius: 24px; padding: 22px; text-align: center;">
                <div>
                    <img style="width: 40px;" :src="require('@/assets/img/sad_emoji.png')" alt="">
                </div>
                <div style="margin-top: 20px; font-weight: 700; font-size: 20px; line-height: 28px;">지금 입단 요청서가 없어요!</div>
                <div style="margin-top: 10px; font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">감독님께 내 축구 실력을 보여줄<br>입단 요청서를 작성해보세요</div>
                <div style="display: flex; gap: 18px; margin-top: 20px;">
                    <div @click="closeRequestPopup" style="width: 100px; font-weight: 600; font-size: 14px; height: 48px; line-height: 48px; text-align: center; border-radius: 12px; background-color: #d9d9d9;">닫기</div>
                    <div @click="goJoinSoccerTeam" style="flex: 1; font-weight: 600; font-size: 14px; color: #fff; height: 48px; line-height: 48px; text-align: center; border-radius: 12px; background-color: var(--color-main);">입단 요청서 작성하기</div>
                </div>
            </div>
        </div>
        <div style="flex: 1;">
            <div v-if="false" style="padding: 0 12px;margin-top:32px;">
                <div @click="showDirectMessageList(); $Util.sendEventClick('사커하우_선수스카웃', true)" style="">
                    <img style="width: 100%;" :src="require('@/assets/img/expert_container.png')" alt="">
                </div>
            </div>
            <div v-if="false" style="padding: 0 12px; margin-top: 32px; margin-bottom: 32px;">
                <div style="font-weight: 700; color: #808080;  margin-bottom: 10px;"><span style="color: #210f03;">축구 질문</span>이 도착했어요 💬</div>
                <swiper style="" ref="swiper" :options="swiperOption" role="tablist">
                    <swiper-slide v-for="each, index in topicData" :key="index + 'topic'" style="width: 100%; display: flex; background-color: #f5f5f5; flex-direction: column; height: 100%; height: 226px; position: relative; border-radius: 12px; padding: 12px; flex-shrink: 0;" role="tab">
                        <!-- <div style="background: #F5F5F5; position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -1;"></div>
                        <img style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -2; object-fit: fill;" :src="require('@/assets/img/test_back.png')" alt=""> -->
                        <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #808080;">
                            대답을 기다리는 피드
                            <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #808080;"></span>
                            <span style="color: #210f03; font-weight: 700;">{{ each.reply_number }}명</span> 참여
                        </div>
                        <div style="display: flex; gap: 8px; align-items: flex-start; margin-bottom: 8px; margin-top: 20px;">
                            <div @click.stop="$Util.showProfile(each.writer_idx)">
                                <ProfileImage :imagePath="each.image_path" style="width: 40px;"></ProfileImage>
                            </div>
                            <div>
                                <div style="font-weight: 700; font-size: 12px; line-height: 24px;">{{ each.nic_name }} <span style="font-size: 10px; color: var(--color-main); margin-left: 4px;">{{ each.position }}</span></div>
                                <div style="display: flex; align-items: center; color: #808080; font-weight: 500; font-size: 12px; line-height: 16px; gap: 4px;">{{ each.place_name }}
                                    <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #808080;"></span>
                                    {{ each.insert_date | agoDateStr }}
                                </div>
                                <div class="ellipsis_multiple_lines" style="font-size: 15px; line-height: 32px; font-weight: 500;">{{ $Util.removeYoutubeLink(each.contents) }}</div>
                            </div>
                        </div>
                        <div style="flex: 1; display: flex; align-items: end; padding-bottom: 8px;">
                            <div @click="showDirectMessageForm(index); $Util.sendEventClick('사커하우_피드_답변하기', true)" style="width: 184px; height: 46px; border-radius: 32px; margin: 0 auto; color: #fff; background: var(--color-main); line-height: 46px; text-align: center; font-weight: 500; font-size: 14px;">지금 바로 답변하기</div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 20px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
                </swiper>
            </div>
            <!-- <div style="margin-top: 12px;">
                <div style="font-weight: 700; margin-bottom: 12px; padding-left: 12px;">인기 게시물</div>
                <div class="hide_scroll" style="background-color: #f5f5f5;  margin-top: 12px; padding: 20px 0; display: flex; align-items: center; gap:16px;">
                    <swiper style="padding: 0 12px; " ref="swiper" :options="swiperOption" role="tablist">
                        <swiper-slide v-for="each, i in noticeEvent" :key="i + 'notice_popular'" :style="{width: noticeEvent.length === 1 ? '100%' : '85%'}" style="flex-shrink: 0; width: 85%; border-radius: 12px; padding: 1px; background: linear-gradient(230.99deg, #4B8AFF 0%, #FF7111 100%);" role="tab">
                            <div style="background-color: #fff; border-radius: 10px; padding: 12px;">
                                <CommonNoticePost :index="i" :showPopularPostPopup="showPopularPostPopup" :isPopular="true" :noticePost="each"></CommonNoticePost>
                            </div>
                        </swiper-slide>
                        <swiper-slide v-for="each, i in popularSoccerhows" :key="i + 'popular'" :style="{width: popularSoccerhows.length === 1 ? '100%' : '85%'}" style="flex-shrink: 0; border-radius: 12px; width: 85%; padding: 12px; background-color: #fff; border-image-source: linear-gradient(230.99deg, #4B8AFF 0%, #FF7111 100%);" role="tab">
                            <CommonPost :hideOption="true" :refresh="refresh" :isPopular="true" :isExpertConfirmed="isExpertConfirmed" :isExpert="isExpert" :isFeed="true" :soccerHows="each"></CommonPost>
                        </swiper-slide>
                    </swiper>
                </div>
            </div> -->
            <!-- <div style="padding: 0px 12px 10px 12px;margin-top:20px;">
                <div style="border-bottom: 1px solid #f5f5f5; padding-bottom: 20px;" v-for="each, i in pollList" :key="i + 'poll'">
                    <CommonPollPost :completeAction="hidePollList" :index="i" :pollPost="each"></CommonPollPost>
                </div>
                <div style=" border-bottom: 1px solid #f5f5f5; padding-bottom: 20px;" v-for="each, i in noticeList" :key="i + 'notice'">
                    <CommonNoticePost :isFeed="true" :completeAction="hideNoticeList" :index="i" :noticePost="each"></CommonNoticePost>
                </div>
            </div> -->
            <!-- <div v-if="!isExpert" style="padding: 0 12px;margin-top:32px;" ref="feed_add_btn_wrap">
                <div @click="addFeed" style="">
                    <img style="width: 100%;" :src="require('@/assets/img/ground_container.png')" alt="">
                </div>
            </div> -->
            <div ref="near_coach" style="margin-top: 30px; margin-bottom: 20px;" v-if="!isExpert && $GlobalStore.isLogin()">
                <div style="display: flex; justify-content: space-between; align-items: end; padding: 0 12px;">
                    <div style="font-weight: 900; line-height: 24px;">축구선수가 꿈이라면<br><span style="color: var(--color-main);">입단 테스트 요청</span>을 해보세요</div>
                    <div @click="goFindSoccerTeam" style="font-size: 12px; line-height: 24px; color: #808080; text-decoration: underline;">축구팀 찾기</div>
                </div>
                <div style="display: flex; gap: 20px; overflow-x: scroll; margin-top: 10px; padding: 0 12px;" class="hide_scroll">
                    <div class="near_coach" style="position: relative" v-for="each, i in nearByCoachList" :key="i + 'near_coach'">
                        <div style="height: 150px; position: absolute; opacity: 0.1; z-index: 1; right: 0; top: 0; display: flex; align-items: center; justify-content: center;">
                            <img style="object-fit: cover; max-width: 100px; max-height: 150px;" :src="$resourcePath + each.team_image_path" alt="">
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center; z-index: 2; position: relative;">
                            <ProfileImage :imagePath="each.image_path" style="width: 40px;"></ProfileImage>
                            <div>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <div style="font-size: 14px; font-weight: 700; line-height: 18px;">{{ each.nic_name }}</div>
                                    <div>
                                        <img style="width: 16px;" v-if="each.coach_type === '감독'" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img style="width: 16px;" v-else :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                </div>
                                <div style="display: flex; gap: 5px; align-items: center; flex: 1; ">
                                    <template v-if="each.licenses">
                                        <img style="width: 10px;" :src="require('@/assets/img/expoert_badge.png')" alt="">
                                        <div class="ellipsis" style="font-weight: 500; flex: 1; font-size: 12px; line-height: 16px;">{{ each.licenses }}</div>
                                    </template>
                                    <template v-else>
                                        <img style="width: 15px;" :src="require('@/assets/img/no_regi_license.png')" alt="">
                                        <div style="font-weight: 500; flex: 1; font-size: 12px; color: #808080; line-height: 16px;">자격증 미등록</div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div style="font-size: 14px; font-weight: 700; margin: 10px 0; color: #606060; line-height: 24px; z-index: 2; position: relative;">{{ each.team_name || '팀 미등록' }}</div>
                        <div @click="showCoachTeam(each)" style="font-weight: 700; height: 41px; background-color: #210f03; color: #fff; border-radius: 12px; line-height: 41px; text-align: center; font-size: 12px; z-index: 2; position: relative;">입단 테스트 도전</div>
                    </div>
                </div>
                <div v-if="false" style="margin-top: 20px; padding: 0 12px;">
                    <div  style="display: flex; padding: 8px 12px; background: #210F031A; border-radius: 4px; justify-content: space-between; align-items: center;">
                        <div style="display: flex; align-items: center; gap: 5px;">
                            <div style="font-size: 14px; font-weight: 900; line-height: 24px; color: var(--color-main);">EVENT</div>
                            <div style="font-weight: 500; font-size: 12px; line-height: 24px;">입단 요청서 작성 이벤트</div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px;"><span style="color: var(--color-main);">{{ eventInfo ? eventInfo.training_left_count : 0 }}</span>/3</div>
                            <div style="width: 90px; height: 12px; box-shadow: 1px 1px 10px 0px #0000001A; background-color: #fff; border-radius: 4px;">
                                <div :style="{ width: (eventInfo ? eventInfo.training_left_count / 3 : 0) * 100 + '%' }" style="height: 100%; background-color: var(--color-main); border-radius: 4px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="false" style="padding-bottom: 12px;">
                <SwipedEventBannerSmall style="padding-bottom: 0;" :home_banners="eventBanner" />
            </div>
            <div v-if="false" style="margin: 0 12px;">
                <div style="margin-bottom: 12px; font-weight: 700; font-size: 14px; line-height: 20px;">📍오늘 바로! 가까운 곳에서 트레이닝 시작! ⚽️</div>
                <AutoScrollWrapper style="height:115px; background-color: #F5F5F5; border-radius:16px;">
                    <div @click="showTeamTraining(each.idx); $Util.sendEventClick('지도_팀트레이닝_자세히보기')" style="padding: 0 12px; display: flex; align-items: center; gap: 12px; padding-top: 8px; padding-bottom: 12px;" v-for="each, i in schedules" :key="i + 'schedule'">
                        <div style="font-weight: 500; line-height: 24px;">{{ each.begin_time }}</div>
                        <div style="flex: 1;">
                            <div style="font-weight: 500; line-height: 24px; flex-shrink: 0;">{{ each.title }}</div>
                            <div style="display: flex; gap: 8px; margin-top: 8px; flex-wrap: wrap; flex: 1;">
                                <div v-if="each.max_cnt" style="padding: 4px 8px; white-space: nowrap; font-size: 12px; font-weight: 500; line-height: 20px; border-radius: 8px; background-color: #ffeadb;">{{ each.max_cnt - 1 | comma }}명</div>
                                <div v-if="each.join_begin_date_time" style="padding: 4px 8px; white-space: nowrap; font-size: 12px; font-weight: 500; line-height: 20px; border-radius: 8px; background-color: #ffeadb;">{{ transTime(each.join_begin_date_time, each.join_end_date_time) }}</div>
                                <div v-if="each.recommend_age" style="padding: 4px 8px; white-space: nowrap; font-size: 12px; font-weight: 500; line-height: 20px; border-radius: 8px; background-color: #ffeadb;">{{ each.recommend_age }}</div>
                                <div v-if="each.sex" style="padding: 4px 8px; white-space: nowrap; font-size: 12px; font-weight: 500; line-height: 20px; border-radius: 8px; background-color: #ffeadb;">{{ each.sex }}</div>
                                <div v-if="each.level" style="padding: 4px 8px; white-space: nowrap; font-size: 12px; font-weight: 500; line-height: 20px; border-radius: 8px; background-color: #ffeadb;">{{ each.level }}</div>
                            </div>
                        </div>
                        <div v-if="isPassTime(each.join_begin_date_time) === TIME_TYPE.JOIN" class="join_btn">지금 참여하기</div>
                        <div v-if="isPassTime(each.join_begin_date_time) === TIME_TYPE.IMMINENT" class="join_btn imminent">마감 임박!</div>
                        <div v-if="isPassTime(each.join_begin_date_time) === TIME_TYPE.CLOSING" class="join_btn closing">마감</div>
                    </div>
                </AutoScrollWrapper>
            </div>
            <div ref="tab_wrapper" style="padding: 20px 12px; padding-bottom: 12px; display: flex; position: sticky; top: 55px; background-color: #fff; z-index: 10;">
                <div style="display: flex; gap: 12px; position: relative">
                    <div @click="setViewTab(VIEW_TAB.POPULAR); $Util.sendEventClick('축구배우기_탭_인기글', true)" style="font-weight: 700; font-size: 18px;">
                        <div :style="{ color: curViewTab === VIEW_TAB.POPULAR ? 'var(--color-main)' : '#210f03' }">인기글</div>
                        <!-- <div v-if="curViewTab === VIEW_TAB.POPULAR" style="height: 1px; width: 100%; background-color: #210f03; margin-top: 6px;"></div> -->
                    </div>
                    <div @click="setViewTab(VIEW_TAB.REAL_TIME); $Util.sendEventClick('축구배우기_탭_실시간게시물', true)" style="font-weight: 700; font-size: 18px;">
                        <div :style="{ color: curViewTab === VIEW_TAB.REAL_TIME ? 'var(--color-main)' : '#210f03' }">실시간 게시물</div>
                        <!-- <div v-if="curViewTab === VIEW_TAB.REAL_TIME" style="height: 1px; width: 100%; background-color: #210f03; margin-top: 6px;"></div> -->
                    </div>
                    <div :style="{transform: curViewTab === VIEW_TAB.POPULAR ? 'translateX(1px)' : 'translateX(60px)', width: curViewTab === VIEW_TAB.POPULAR ? '47px' : '97px'}" style="position: absolute; height: 2px; width: 97px; background-color: var(--color-main); transition: all .2s; bottom: -8px; "></div>
                </div>
            </div>
            <div style="padding: 0 12px; padding-top: 8px;">
                <!--<div style="font-weight: 700; margin-bottom: 12px;">모든 피드</div>-->
                <div v-show="curViewTab === VIEW_TAB.REAL_TIME" style="margin-bottom: 20px; border-bottom: 1px solid #f5f5f5; padding-bottom: 20px;" v-for="each, i in soccerHows" :key="i + 'post'">
                    <CommonPost :recommendUserList="recommendUser" :isNeedRecommendSection="i === 1 || (soccerHows.length <= 2 && soccerHows.length === i + 1) ? true : false" :refresh="refresh" :isExpertConfirmed="isExpertConfirmed" :isExpert="isExpert" :isFeed="true" :soccerHows="each" :isRealTime="true"></CommonPost>
                </div>
                <div v-show="curViewTab === VIEW_TAB.POPULAR" style="margin-bottom: 20px; border-bottom: 1px solid #f5f5f5; padding-bottom: 20px;" v-for="each, i in popularSoccerhows" :key="i + 'popular'">
                    <CommonPost :recommendUserList="recommendUser" :isNeedRecommendSection="i === 1 || (popularSoccerhows.length <= 2 && popularSoccerhows.length === i + 1) ? true : false" :refresh="refresh" :isExpertConfirmed="isExpertConfirmed" :isExpert="isExpert" :isFeed="true" :soccerHows="each" :isPopular="true"></CommonPost>
                </div>
            </div>
        </div>
        <LearnSoccerWriteForm :topics="mainData.topics" :refresh="refresh" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :complete-action="() => { getLearnData(); refresh(); }" :formType="formType"></LearnSoccerWriteForm>
        <transition name="fade" appear>
            <SendDirectMessage :isShowDirectMessageForm="isShowDirectMessageForm" :topicData="topicData" :startIndex="startIndex" :closeDirectMessageForm="closeDirectMessageForm" :complete-action="() => { getLearnData(); refresh(); }"></SendDirectMessage>
        </transition>
        <!-- <div class="float_plus_btn">
            <img style="width: 28px;" :src="require('@/assets/img/plus_black.png')" alt="">
        </div> -->
        <transition name="fade">
            <InteractionOfScale :scaleNumber="'0.91'" :style="{ bottom: 80 + navagaionBarHeight + 'px' }" v-if="is_show_feed_add_btn && !isExpert" style="position:fixed; right: 12px;">
                <div @click="addFeed">
                    <img :src="require('@/assets/img/feed_add_btn.png')" style="width:52px; height:52px;">
                </div>
            </InteractionOfScale>
        </transition>
        <AfterFindPositionPopup :btnClickEvent="addFeed"></AfterFindPositionPopup>
        <!-- <div v-if="$GlobalStore.loginInfo().is_temp_coach == 0 && (!writtenInfo || (writtenInfo && writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.REJECTED))" @click="showInstargramEventPopup" :style="{ bottom: navagaionBarHeight + 136 + 'px' }" style="position: fixed; right: 5px; z-index: 20;">
            <img style="width: 75px;" :src="require('@/assets/img/insta_event.png')" alt="">
        </div>
        <div v-else-if="$GlobalStore.loginInfo().is_temp_coach == 0 && writtenInfo && writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.WAITING" :style="{ bottom: navagaionBarHeight + 136 + 'px' }" style="position: fixed; right: 5px; z-index: 20;">
            <img style="width: 75px;" :src="require('@/assets/img/insta_event_complete.png')" alt="">
        </div> -->
    </div>
</template>

<script>
const FORM_TYPE = {
    TOPIC: 'TOPIC',
    SKILL: 'SKILL'
}

const TIME_TYPE = {
    IMMINENT: '마감임박',
    CLOSING: '마감',
    JOIN: '참여'
}

const VIEW_TAB = {
    POPULAR: '인기',
    REAL_TIME: '실시간'
}
// import CommonPollPost from '@/components/common/CommonPollPost'
import SendDirectMessage from '@/components/soccerhowmain/SendDirectMessage.vue'
import SwipedEventBannerSmall from "@/components/common/home/SwipedEventBannerSmall";
import CommonPost from '@/components/soccerhowmain/CommonPost'
import ProfileImage from '@/components/common/ProfileImage'
import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
import { SOCCER_HOW_TYPE, TEAM_TYPE } from '@/Constants';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import InteractionOfScale from '@/components/common/InteractionOfScale.vue'
// import CommonNoticePost from '@/components/common/CommonNoticePost'
import moment from 'moment'
import AutoScrollWrapper from '@/components/common/AutoScrollWrapper'
import AfterFindPositionPopup from '@/components/common/AfterFindPositionPopup'
// import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import { MEMBER_INSTARGRAM_EVENT_STATE } from '@/Constants'
export default {
    name: 'LearnSoccer',
    components: {
        CommonPost, ProfileImage, AfterFindPositionPopup, SwipedEventBannerSmall, AutoScrollWrapper, LearnSoccerWriteForm, swiper, swiperSlide, SendDirectMessage, InteractionOfScale
    },
    props: {
        refreshFlag: {
            type: Boolean,
            default: false
        },
        initRefreshFlag: {
            type: Function,
            default: () => { }
        },
        isExpert: {
            type: Boolean,
            default: false
        },
        soccerHows: {
            type: Array,
            default: () => { }
        },
        mainData: {
            type: Object,
            default: () => { }
        },
        isExpertConfirmed: {
            type: Boolean,
            default: false
        },
        refresh: {
            type: Function,
            default: () => { }
        },
        noticeList: {
            type: Array,
            default: () => { }
        },
        noticeEvent: {
            type: Array,
            default: () => { }
        },
        hideNoticeList: {
            type: Function,
            default: () => { }
        },
        showPopularPostPopup: {
            type: Function,
            default: () => { }
        },
        popularSoccerhows: {
            type: Array,
            default: () => []
        },
        curViewTab: {
            type: String,
            default: VIEW_TAB.POPULAR
        },
        setViewTab: {
            type: Function,
            default: () => { }
        },
        eventBanner: {
            type: Array,
            default: () => {}
        },
        showRequestTestPopup: {
            type: Function,
            default: () => { }
        }
    },
    computed: {
        isMeCoach() {
            let isMeCoach;
            if (this.$GlobalStore.isLogin()) {
                isMeCoach = this.$GlobalStore.loginInfo().is_temp_coach == 1 ? true : false
            } else {
                isMeCoach = false
            }

            if (isMeCoach) {
                return true
            } else {
                return false
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            // Swiper 강제 업데이트
            if (this.isExpert) {
                if (this.$refs.swiper && this.$refs.swiper.swiper) {
                    this.$refs.swiper.swiper.update();
                }
            }
        });
    },
    data() {
        return {
            isShowRequestPopup: false,
            MEMBER_INSTARGRAM_EVENT_STATE: MEMBER_INSTARGRAM_EVENT_STATE,
            TEAM_TYPE: TEAM_TYPE,
            isEnableNextPageHandle: true,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            page: 1,
            FORM_TYPE: FORM_TYPE,
            formType: FORM_TYPE.TOPIC,
            isShowWriteForm: false,
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 12, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            isShowDirectMessageForm: false,
            startIndex: 0,
            topicData: [],
            is_show_feed_add_btn: false,
            navagaionBarHeight: 0,
            winH: 0,
            pollList: [],
            isCompleteGetPollList: false,
            test: false,
            schedules: [],
            TIME_TYPE: TIME_TYPE,
            VIEW_TAB: VIEW_TAB,
            nearByCoachList: [],
            recommendUser: [],
            writtenInfo: null,
            eventInfo: null,
        }
    },
    methods: {
        closeRequestPopup() {
            this.isShowRequestPopup = false
        },
        goJoinSoccerTeam() {
            this.isShowRequestPopup = false
            this.$GlobalStore.addModal('SelectPlayerType')
        },
        goFindSoccerTeam() {
            this.$router.push({ path: '/view/soccer_join?isFromHome=true' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        async checkIsSoccerHowJoinWritten() {
            const res = await this.$Axios.get('/api/soccerhow/check/join/written')
            return res.data.isSoccerHowJoinWritten
        },
        async showCoachTeam(each) {
            const isSoccerHowJoinWritten = await this.checkIsSoccerHowJoinWritten()
            const availableCntByInstar = this.eventInfo.available_cnt_by_instar;
            const availbaleCntByTraining = this.eventInfo.available_cnt_by_training;

            if ((availableCntByInstar >= 1 || availbaleCntByTraining >= 1) || isSoccerHowJoinWritten) {
                this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: each.team_idx })
            } else {
                this.isShowRequestPopup = true
                // this.showRequestTestPopup()
            }
        },
        async getNearbyCoachList() {
            const res = await this.$Axios.get('/api/member/close/list/coach')

            this.nearByCoachList = res.data.members
            this.nearByCoachList = this.nearByCoachList.filter(each => each.member_idx != 462310 && each.member_idx != 442092)
        },
        transTime(beginTime, endTime) {
            const start = new Date(beginTime);
            const end = new Date(endTime);

            const differenceInMilliseconds = end - start;

            const differenceInHours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
            const differenceInMinutes = Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));

            let result = '';
            if (differenceInHours > 0) {
                result += `${differenceInHours}시간 `;
            }
            if (differenceInMinutes > 0) {
                result += `${differenceInMinutes}분`;
            }

            // 결과 반환 (공백 제거)
            return result.trim();
        },
        isPassTime(beginTime) {
            const now = moment(); // 현재 시간
            const beginMoment = moment(beginTime); // beginTime을 moment 객체로 변환

            if (now.isAfter(beginMoment)) {
                return TIME_TYPE.CLOSING;
            } else if (beginMoment.diff(now, 'hours') <= 4) {
                return TIME_TYPE.IMMINENT;
            }
            return TIME_TYPE.JOIN;
        },
        async getTeamTrainingListNearBy(isRefresh) {
            if (isRefresh) {
                this.schedules = []
            }
            const parameters = {}
            parameters.is_nearby = true

            const res = await this.$Axios.get('/api/find/team/map/list/learn', { params: parameters })
            this.schedules = res.data.schedules
        },
        showTeamTraining(idx) {
            this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: idx })
        },
        async getPollList(isRefresh) {
            if (isRefresh) {
                this.pollList = []
            }
            const res = await this.$Axios.get('/api/poll/list')

            const pollList = res.data.poll_list
            this.pollList = pollList
            this.pollList = this.pollList.filter(poll => !poll.is_me_poll_hidden)
            this.isCompleteGetPollList = true
        },
        hidePollList(index) {
            this.$delete(this.pollList, index)
        },
        addFeed() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.showWriteForm(FORM_TYPE.SKILL);
            this.$Util.sendEventClick('사커하우_피드_작성하기')
        },
        __detectScroll(e) {
            e;
            if (this.$refs.feed_add_btn_wrap) {
                const rect = this.$refs.feed_add_btn_wrap.getBoundingClientRect()
                if (rect.bottom < 56) {
                    this.is_show_feed_add_btn = true;
                } else {
                    this.is_show_feed_add_btn = false;
                }
            }
        },
        async getLearnData() {
            const res = await this.$Axios.get('/api/home/target/learn')
            const learnData = res.data.soccerhows
            this.topicData = learnData.slice(0, 7)
        },
        showDirectMessageList() {
            if (this.isExpert && !this.isExpertConfirmed) {
                this.$GlobalStore.setIsShowBookmarkPopupNotExpert()
                return
            }
            this.$GlobalStore.addModal('DirectMessageList', { transitionName: 'bottom' })
        },
        showDirectMessageForm(index) {
            if (this.isExpert && !this.isExpertConfirmed) {
                this.$GlobalStore.setIsShowBookmarkPopupNotExpert()
                return
            }
            this.isShowDirectMessageForm = true
            window.deviceInfoManager.setStatusBarTextColor('white');
            this.startIndex = index
        },
        closeDirectMessageForm() {
            window.deviceInfoManager.setStatusBarTextColor('dark');
            this.isShowDirectMessageForm = false
        },
        showWriteForm(formType) {
            this.formType = formType
            this.isShowWriteForm = true
        },
        closeWriteForm() {
            this.isShowWriteForm = false
        },
        async getRecommendUser() {
            const res = await this.$Axios.get('/api/recommend_member/random')

            this.recommendUser = res.data.members
        },
        async getWrittenInfo() {
            const res = await this.$Axios.get('/api/soccerhow/request/instargram_event/certified')
            this.writtenInfo = res.data.member_instargram_event
        },
        async getEventInfo() {
            const res = await this.$Axios.get('/api/soccerhow/request/available/info')
            this.eventInfo = res.data
        },
        showInstargramEventPopup() {
            this.$GlobalStore.addModal('UploadInstaImage', {
                transitionName: '',
                isModalBackTransparent: true,
                writtenInfo: this.writtenInfo,
                completeAction: () => {
                    this.getWrittenInfo()
                }
            })
        }
    },
    watch: {
        refreshFlag(newVal) {
            if (newVal) {
                this.initRefreshFlag()
                // this.getPollList(true)
            }
        },
        noticeEvent() {
            if (this.noticeEvent.length > 0) {
                this.test = true
            }
        },
    },
    created() {
        // this.getTeamTrainingListNearBy()
        // this.getPollList()
        this.getEventInfo()
        this.getWrittenInfo()
        if (this.isExpert) {
            this.getLearnData()
        }
        if (!this.isExpert) {
            this.getNearbyCoachList()
        }
        this.getRecommendUser()
        this.navagaionBarHeight = this.$GlobalStore.navigationBarHeight()
    }
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.near_coach {
    width: 240px;
    /* height: 200px; */
    border: 1px solid #ebebeb;
    flex-shrink: 0;
    border-radius: 24px;
    overflow: hidden;
    padding: 12px;
    display: flex;
    flex-direction: column;
}

.join_btn {
    white-space: nowrap;
    width: 90px;
    flex-shrink: 0;
    padding: 8px 0;
    background-color: var(--color-main);
    border-radius: 12px;
    color: #fff;
    line-height: 20px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid #eb5800;
    text-align: center;
}

.imminent {
    background: linear-gradient(180deg, #E13800 53.81%, #FFC778 100%);
}

.closing {
    background-color: #d9d9d9;
    border: 1px solid #bbbbbb;
    color: #808080;
}

.ellipsis_multiple_lines {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.box_title {
    width: 220px;
    border-radius: 12px;
    height: 120px;
    background: linear-gradient(90deg, rgba(17, 88, 255, 0.2) 0%, rgba(255, 113, 17, 0.2) 100%);
    padding: 12px;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #606060;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #0F0600
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    margin: 0 2px;
}

.swiper-container>>>.swiper-wrapper {
    align-items: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s;
}

.fade-enter {
    opacity: 0;
    /* 요소가 나타날 때 초기 상태 */
}

.fade-leave-to {
    opacity: 0;
    /* 요소가 사라질 때 최종 상태 */
}

.float_plus_btn {
    position: fixed;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 12px;
    bottom: 80px;
    box-shadow: 0px 4px 36px 0px #210F0314;
    background-color: #f5f5f5;
    border: 1px solid #FFFFFFCC;
    backdrop-filter: blur(20px);
    z-index: 9;
    backdrop-filter: blur(15px) contrast(1.35);
    -webkit-backdrop-filter: blur(15px) contrast(1.35);
}
</style>